'use strict';
/* ==========================================================================
   core-local/hooks.js — "The Big Drop II" (heat): this lesson's hooks into the shared engine v2
   (shared/engine/v2/core/game.js reads window.LessonHooks). The physics cast, reused (DESIGN.md §3).

   speakers: the name tag + colour of each voice in the portrait dock's captions (core/dock.js), as in lessons/energy.
   captions: fallback caption text + speaker for every line of content/labs.json (every beat's say, hint, after and on;
             after may be a list or {outcome: list}; on = {event: list}), so a line captions before its clip arrives.
             assets/vo/lines.json / who.json (what was recorded) win once lesson.json preload.voice names them.
   lab:      the shared lab kit's cast (Max lower left, Dr. Voss lower right), the teacher (Voss writes the given steps),
             no extra pad key, and the CASE-FILE skin over the kit's collage skin (core-local/heatkit.js HeatKit.skin:
             manila folder paper, typed evidence tags, a red pencil). shared/engine/v2/LAB.md §0, §12.
   The STAMPED card: the engine's default (lesson.json steps[].card + completeCard "CASE CLOSED", nextFrom "finished").
   Puppets: the engravings of lessons/energy (copied into assets/img/). core/puppet.js already knows Voss and Max; the
            poses and facings below are the same values (energy's art: voss / voss_point face the camera (0),
            max_cross looks left (−1), max_point points right (+1)), set here so this lesson does not depend on them.
   ========================================================================== */
window.LessonHooks = {
  speakers: { voss: { name: 'Dr. Voss', color: '#e0533d' }, max: { name: 'Max', color: '#2e9c8e' } },
  captions({ labs } = {}) {
    const text = {}, who = {};
    const add = l => { if (l && l.id) { text[l.id] = l.text; who[l.id] = l.who; } };
    const each = v => (Array.isArray(v) ? v.forEach(add) : v && typeof v === 'object' ? Object.values(v).forEach(ls => (Array.isArray(ls) ? ls : []).forEach(add)) : null);
    const L = labs && labs.labs;
    if (L) for (const k of Object.keys(L)) for (const b of (L[k] && L[k].beats) || []) { each(b.say); each(b.hint); each(b.after); each(b.on); }
    return { text, who };
  },
  /* the shared lab kit's configuration (shared:core/lab.js, LAB.md §0): Max in the lower-left slot, Dr. Voss in the
     lower-right one; she speaks a line with no "who" and writes in the given steps; no extra pad key; the case-file skin */
  lab: {
    cast: { left: { who: 'max' }, right: { who: 'voss' } },
    teacher: 'voss',
    skin: (typeof window !== 'undefined' && window.HeatKit && window.HeatKit.skin) || undefined,
  },
};

/* the cast's poses (core/puppet.js: pose alias → image name; the default pose per character; which way each faces) */
(function () {
  const P = typeof window !== 'undefined' && window.Puppet;
  if (!P) return;                                   // node (tools/contentcheck.js reads only the speakers)
  P.POSES.voss = Object.assign(P.POSES.voss || {}, { voss: 'voss', point: 'voss_point', voss_point: 'voss_point' });
  P.POSES.max = Object.assign(P.POSES.max || {}, { cross: 'max_cross', point: 'max_point', max_cross: 'max_cross', max_point: 'max_point' });
  P.DEFAULT.voss = 'voss'; P.DEFAULT.max = 'max_cross';
  Object.assign(P.NATIVE, { voss: 0, voss_point: 0, max_cross: -1, max_point: 1 });
})();
